import { Module } from 'vuex';
import { ILoginStore } from '../../../shared/store/shared.types';
import { IAuthenticationState } from './authentication.types';

import actions from './authentication.actions';
import mutations from './authentication.mutations';
import getters from './authentication.getters';

const initialState: IAuthenticationState = {
  pinCode: '',
  networkError: undefined,
  authError: undefined,
};

const authenticationModule: Module<IAuthenticationState, ILoginStore> = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};

export default authenticationModule;
